import useRankingTable from '../../../hooks/useRankingTable';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  ranking: {
    name: 'Ranking',
    isStatic: false
  },
  market_type: {
    name: 'Market type',
    isStatic: false
  },
  market_code: {
    name: 'Market code',
    isStatic: false
  },
  aggregated_value: {
    name: 'Aggregated value',
    isStatic: false
  }
};

export function PrincipalMarkets({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.PRINCIPAL_MARKETS,
    onChangeFund,
    schema: schema.PRINCIPAL_MARKETS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.PRINCIPAL_MARKETS?.field_names || [],
    order: 71,
    tableName: 'PRINCIPAL_MARKETS',
    columnLables,
    isMultiFunds,
    funds
  });

  return (
    <StyledTables id="fca-reporttables-principal-markets-group">
      {tables.map((rows, index) => (
        <Table
          id={`fca-reporttables-principal-markets-table-${index + 1}`}
          key={index + 'PRINCIPAL_MARKETS'}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
        />
      ))}
    </StyledTables>
  );
}
